import { render, staticRenderFns } from "./TopicManageDetail.vue?vue&type=template&id=7b963711&scoped=true"
import script from "./TopicManageDetail.vue?vue&type=script&lang=js"
export * from "./TopicManageDetail.vue?vue&type=script&lang=js"
import style0 from "./TopicManageDetail.vue?vue&type=style&index=0&id=7b963711&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b963711",
  null
  
)

export default component.exports